import {ReactNode} from 'react'
import cn from 'clsx'

import './Paper.scss'

interface PaperProps {
  children: ReactNode
  className?: string
  relative?: boolean
  fullHeight?: boolean
}

export default function Paper({
  children,
  className,
  relative,
  fullHeight,
}: PaperProps) {
  return (
    <section
      className={cn(
        className,
        'Paper',
        relative && 'Paper_relative',
        fullHeight && 'Paper_fullHeight'
      )}
    >
      {children}
    </section>
  )
}
